import * as React from 'react'
import {BrowserRouter, Route, Routes} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import Header from './components/Header'
import Footer from './components/Footer'
import MainPage from './pages/Main'
import Content from './pages/Content'
import Family from './pages/Family'
import Index from './pages/Index'
import {loadAllItemsAction} from './store/actions/General'
import Redirector from './Redirector'
import './App.sass'

function App() {
  const dispatch = useDispatch()
  React.useEffect(() => {
    dispatch(loadAllItemsAction())
  }, [dispatch])


  return (
    <BrowserRouter>
      <div style={{ display: 'flex', flexDirection: 'column', maxHeight: '100vh' }}>
        <Header />
        <Routes>
          <Route path='/' exact element={<MainPage />} />
          <Route path='/content' exact element={<Content />} />
          <Route path='/family/:familyId' exact element={<Family />} />
          <Route path='/family/:familyId/:subfamilyId' exact element={<Family />} />
          <Route path='/index/:indexId' exact element={<Index />} />
          <Route path='/FactSheet.aspx' exact element={<Redirector />} />
          <Route path="*" element={<Redirector />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  )
}

export default App
